<template>
    <div>
        <div class="inner">
            <el-row class="onlyMobile">
                <el-col>
                    <h3>Dokumentacja</h3>
                </el-col>
            </el-row>
            <div v-loading="loading">
                <div v-if="!loading">
                    <markdown-panel/>
                    <markdown-html/>
                </div>
            </div>
        </div>
        <back-to-top />
    </div>
</template>
<script>
import MarkdownPanel from '../../../components/Sdk/MarkdownPanel'
import MarkdownHtml from '../../../components/Sdk/MarkdownHtml'
import { apiClass } from '../../../classes/api.class'
import { htmlClass } from '../../../classes/html.class'
import { ToolsClass } from '../../../classes/tools.class'
import { mapMutations, mapState } from 'vuex'
import { ROUTING } from '../../../const/routing.const'
import BackToTop from '../../../components/Layout/BackToTop'

const childSectionRegex = /^\d+\.(.+)$/
const currentSectionRegex = /^(\d+)/

export default {
  name: 'AutopaySdkDoscDeviceView',
  components: {
    BackToTop,
    MarkdownPanel,
    MarkdownHtml
  },
  data: () => ({
    loading: true,
    chapterData: null
  }),
  props: {
    chapter: {
      type: String,
      default: ''
    },
    selectedDevice: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      lang: state => state.sdk.lang,
      version: state => state.sdk.version,
      section: state => state.sdk.section,
      device: state => state.sdk.device,
      navigation: state => state.sdk.navigation,
      currentNavigation: state => state.sdk.currentNavigation
    })
  },
  methods: {
    ...mapMutations([
      'setSdkCurrentDevice',
      'setSdkNavigationArray',
      'setSdkCurrentSection',
      'setSdkLanguage'
    ]),
    isHashSet () {
      return window.location.hash && window.location.hash.length > 1
    },
    getNavigationJson () {
      this.loading = true
      if (!this.version) {
        setTimeout(() => {
          this.getNavigationJson()
        }, 100)
        return
      }
      apiClass.getSdkFile(this.version, 'menu', '', 'docs', '.json')
        .then(response => {
          this.setSdkNavigationArray(response)
          if (!this.chapterData) {
            this.initDocs()
          } else {
            this.changeDocs()
          }
        },
        error => {
          console.error(error)
        })
    },
    initDocs () {
      this.getAllChaptersInBackground()
      if (!this.chapter) {
        this.redirectToFirstChapter()
        return
      }
      this.getChapterData()
      this.goToChapter()
    },
    changeDocs () {
      this.getAllChaptersInBackground()
      this.chapterData = this.findChapterBySection()
      this.$router.push(ROUTING.autopaySdk.docs.main + '/' + this.device + '/' + this.chapterData.chapter + (this.chapterData.index !== this.chapterData.section ? this.chapterData.anchor : ''))
      this.goToChapter()
    },
    getAllChaptersInBackground () {
      this.currentNavigation.forEach(nav => {
        apiClass.getSdkFile(this.version, '', this.device, this.lang, '-' + nav.index + '.html')
      })
    },
    getChapterData () {
      if (this.isHashSet()) {
        this.chapterData = this.findChapterByAnchor()
        if (this.chapterData) {
          return
        }
      }
      this.chapterData = this.findChapterByName()
      if (this.isHashSet() && this.chapterData) {
        window.location.hash = ''
      }
    },
    goToChapter () {
      if (this.chapterData) {
        this.getChapterHtml()
      } else {
        this.findChapter()
      }
    },
    findChapter () {
      let foundChapter
      let foundSubmenu

      ToolsClass.each(this.navigation[this.device], (navigation, lang) => {
        if (lang === this.lang || foundChapter) {
          return
        }
        foundChapter = this.findChapterByName(navigation)
      })

      if (!foundChapter) {
        this.redirectToFirstChapter()
        return
      }

      if (this.isHashSet()) {
        foundSubmenu = this.findChapterByAnchor(foundChapter.submenu)
      }

      if (foundSubmenu) {
        foundChapter = foundSubmenu
      }

      this.setSdkCurrentSection(foundChapter.section)
      this.setSdkLanguage(foundChapter.lang)
    },
    findChapterByName (navigation) {
      navigation = navigation || this.currentNavigation
      return navigation.find(el => el.chapter === this.chapter)
    },
    findChapterBySection (navigation) {
      navigation = navigation || this.currentNavigation
      let searchResult = navigation.find(el => el.section === this.section)
      if (!searchResult) {
        navigation.forEach(el => {
          if (searchResult) {
            return
          }
          searchResult = this.findChapterBySection(el.submenu)
        })
      }
      if (!searchResult && navigation === this.currentNavigation) {
        searchResult = this.findNearestSection()
      }
      return searchResult
    },
    findChapterByAnchor (navigation) {
      navigation = navigation || this.currentNavigation
      let searchResult = navigation.find(el => el.anchor === window.location.hash)
      if (!searchResult) {
        navigation.forEach(el => {
          if (searchResult) {
            return
          }
          searchResult = this.findChapterByAnchor(el.submenu)
        })
      }
      return searchResult
    },
    findNearestSection (section, navEl) {
      section = section || this.section
      if (!section) {
        return
      }
      const navSec = navEl ? navEl.section + '.' : ''
      navEl = navEl ? navEl.submenu : this.currentNavigation
      const currentSection = section.match(currentSectionRegex)[1]
      const childMatch = section.match(childSectionRegex)
      const childSection = childMatch ? childMatch[1] : null

      for (let i = currentSection; i > 0; i--) {
        const navResult = navEl.find(nav => nav.section === navSec + i)
        if (navResult) {
          if (currentSection === i && childSection && navResult.submenu.length) {
            return this.findNearestSection(childSection, navResult)
          } else {
            return navResult
          }
        }
      }
    },
    redirectToFirstChapter () {
      this.$router.push(ROUTING.autopaySdk.docs.main + '/' + this.device + '/' + this.currentNavigation[0].chapter)
    },
    getChapterHtml () {
      if (!this.chapterData) {
        this.findChapter()
        return
      }
      ToolsClass.moveToTop()
      this.loading = true
      if (!this.lang || !this.version) {
        setTimeout(() => {
          this.getChapterHtml()
        }, 100)
        return
      }
      apiClass.getSdkFile(this.version, '', this.device, this.lang, '-' + this.chapterData.index + '.html')
        .then(
          response => {
            try {
              htmlClass.prepareHtml(response)
              if (!this.section && this.chapterData.section === '1') {
                setTimeout(() => {
                  window.dispatchEvent(new Event('scroll'))
                  ToolsClass.scrollTop()
                })
                return
              }
              setTimeout(() => {
                window.dispatchEvent(new Event('scroll'))
                ToolsClass.moveToElement(document.querySelector(this.chapterData.anchor))
              })
            } catch (err) {
              console.error(err)
            }
          },
          error => {
            console.error(error)
          })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    device: function (newValue) {
      if (newValue !== this.selectedDevice) {
        this.changeDocs()
      }
    },
    lang: function (newValue, oldValue) {
      if (oldValue) {
        this.changeDocs()
      }
    },
    version: function (newValue, oldValue) {
      if (oldValue) {
        this.getNavigationJson()
      }
    },
    chapter: function (newValue) {
      if (newValue) {
        this.getChapterData()
        this.goToChapter()
      }
    }
  },
  created () {
    this.setSdkCurrentDevice(this.selectedDevice)
    this.getNavigationJson()
  }
}
</script>
